// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1780":"cd8769ef","4252":"8bf8f36c","4958":"f619925e","5355":"6d396745","5866":"b8794b2e","7227":"7cec4b69","8670":"43823be8"}[chunkId] + ".chunk.css";
};